import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gavel, Network, Radio } from "lucide-react";
import { api, money } from "../lib/api";
import { NeonButton } from "./common";

export const StrategyPanel = ({ disputeId, onChanged }) => {
  const [s, setS] = useState(null);
  const load = () => api.get(`/disputes/${disputeId}/strategy`).then((r) => setS(r.data));
  useEffect(() => { load(); }, [disputeId]); // eslint-disable-line
  if (!s) return null;
  const appeal = async () => {
    try {
      const { data } = await api.post(`/disputes/${disputeId}/appeal`);
      toast.success(data.dry_run ? "Appeal simulated (dry-run)" : "Appeal filed");
      load(); onChanged?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Appeal failed"); }
  };
  const block = async (r) => { await api.post("/fraud/block", { kind: r.field, value: r.value }); toast.success(`${r.value} blocked at checkout`); };
  return (
    <div className="space-y-4" data-testid="strategy-panel">
      <div className="flex items-end justify-between">
        <div><p className="label-xs">Predicted win</p><p className="font-mono text-4xl font-extrabold text-brand tabular" data-testid="strategy-predicted-win">{s.predicted_win}%</p></div>
        <span className="font-mono text-[11px] text-right max-w-[60%] text-white" data-testid="strategy-action">{s.action}</span>
      </div>
      <p className="text-xs text-white/55" data-testid="strategy-reasoning">{s.reasoning}</p>
      {s.consent_proof?.statement && (
        <div className="p-3 border border-brand/30 text-xs text-white/75" data-testid="consent-proof">
          <p className="font-mono text-[10px] text-brand mb-1">CONSENT PROOF · INCLUDED IN EVERY DRAFT</p>{s.consent_proof.statement}
        </div>
      )}
      {s.issuer_rewards?.length > 0 && <p className="font-mono text-[10px] text-accent2" data-testid="issuer-rewards-hint">{"ISSUER REWARDS: " + s.issuer_rewards.join(" · ").toUpperCase()}</p>}
      <div className="flex gap-2 text-xs text-white/70"><Radio className="w-3.5 h-3.5 text-accent2 shrink-0 mt-0.5" /><span><b className="text-white">{s.channel}</b> · {s.timing}</span></div>
      {s.appeal && (
        <div className={`p-3 border ${s.appeal.recommend ? "border-brand/40" : "border-white/10"}`} data-testid="appeal-recommendation">
          <p className="font-mono text-[10px] tracking-[0.15em]" style={{ color: s.appeal.recommend ? "#CCFF00" : "#888" }}>{s.appeal.recommend ? "APPEAL RECOMMENDED" : "APPEAL NOT RECOMMENDED"}</p>
          <p className="text-xs text-white/70 mt-1">{s.appeal.summary} Expected value {money(s.appeal.expected_value)}.</p>
          <NeonButton className="mt-2" variant={s.appeal.recommend ? "primary" : "ghost"} onClick={appeal} data-testid="file-appeal-btn"><Gavel className="w-3 h-3" /> File appeal</NeonButton>
        </div>
      )}
      {s.rings.map((r) => (
        <div key={r.field} className="p-3 border border-[#F87171]/40 text-xs" data-testid={`ring-flag-${r.field}`}>
          <p className="font-mono text-[10px] text-[#F87171] flex items-center gap-2"><Network className="w-3 h-3" /> FRAUD-RING SIGNAL · {r.field.replace("_", " ")}</p>
          <p className="text-white/70 mt-1">{r.value} is linked to {r.other_disputes} other dispute(s). Block it and alert issuers to suspected organized fraud.</p>
          <NeonButton variant="danger" className="mt-2" onClick={() => block(r)} data-testid={`block-${r.field}-btn`}>Block {r.field.replace("_", " ")}</NeonButton>
        </div>
      ))}
    </div>
  );
};
